// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[v-cloak][data-v-27a87756] {\n  display: none;\n}\nh6[data-v-27a87756] {\n  font-size: 0.7rem;\n  color: #737373;\n}\n.icon[data-v-27a87756] {\n  text-align: center;\n}\n.controls[data-v-27a87756] {\n  display: grid;\n  /*grid-template-columns: 1fr 1fr;*/\n  grid-template-columns: 2fr 6fr 4fr;\n  gap: 8px;\n  align-items: center;\n}\n#photoPermission[data-v-27a87756] {\n  margin-bottom: 0;\n}\n.switch[data-v-27a87756] {\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
